import $ from "jquery";
import { checkInlineDoubleEmail } from "../helper/checkInlineDoubleEmail";
import { checkInlineDoublePassword } from "../helper/checkInlineDoublePassword";
import { upperCaseFirst } from "../helper/upperCaseFirst";
import Tracing from "../../tracing/Tracing";

/**
 *
 * @param {Mailchecker} mailChecker
 */
export function validateMail(mailChecker) {
  const mailInput = document.getElementById('mail');
  if (mailInput instanceof HTMLInputElement) {
    // can't done with model-values because of the angular-validation
    mailInput.addEventListener('keyup', () => {
      mailChecker.check(mailInput.value);
    });
  }
}



const UserController = (scope, UserControl, Mailchecker) => {

  scope.Mailchecker = Mailchecker;

  validateMail(Mailchecker);

  scope.useSuggestion = function () {
    UserControl.customer.email = Mailchecker.useSuggestion();
  };

  scope.UserControl = UserControl;
  scope.customer = UserControl.customer;
  // if UserControl.customer was new created the $scope.customer must be set again,
  // because the $scope.customer may be empty
  scope.$watch('UserControl.customer', function () {
    scope.customer = UserControl.customer;
  });

  scope.validatePassword = () => {
    const passwordConfirmField = document.getElementById("register-password-confirm-field");

    if (passwordConfirmField) {
      const password = UserControl.customer.password;
      const passwordConfirm = UserControl.customer.passwordConfirm;

      if (!password || !passwordConfirm || password !== passwordConfirm) {
        const translations = scope.translations;

        if (typeof translations[ 'custom' ] === "undefined" || typeof translations[ 'custom' ][ 'repeat_password_validation' ] === "undefined") {
          translations[ 'custom' ] = translations;
        }
        passwordConfirmField.setCustomValidity(translations[ 'custom' ][ 'repeat_password_validation' ]);
      } else {
        passwordConfirmField.setCustomValidity("");
      }
    }
  };

  scope.plzMinLength = 1;
  scope.plzDelMinLength = 1;
  scope.plzMaxLength = UserControl.formValidation.postcode.max;
  scope.plzDelMaxLength = UserControl.formValidation.postcode.max;

  scope.$watch('UserControl.customer.land', function (newValue) {
    const postcodeValidation = getPostcodeValidationPreset(newValue.toString());
    scope.plzMinLength = postcodeValidation.min;
    scope.plzMaxLength = postcodeValidation.max;
    UserControl.formValidation.postcode.ngPattern = postcodeValidation.regEx;
  });

  scope.$watch('UserControl.customer.land_del', function (newValue) {
    const delPostcodeValidation = getPostcodeValidationPreset(newValue.toString());
    scope.plzDelMinLength = delPostcodeValidation.min;
    scope.plzDelMaxLength = delPostcodeValidation.max;
    UserControl.formValidation.postcodeDel.ngPattern = delPostcodeValidation.regEx;
  });



  scope.$watch('UserControl.customer.vorname', function (newValue, oldValue) {
    if (!newValue || newValue === oldValue) {
      return;
    }
    UserControl.customer.vorname = upperCaseFirst(newValue);
  });
  scope.$watch('UserControl.customer.vorname_del', function (newValue, oldValue) {
    if (!newValue || newValue === oldValue) {
      return;
    }
    UserControl.customer.vorname_del = upperCaseFirst(newValue);
  });
  scope.$watch('UserControl.customer.nachname', function (newValue, oldValue) {
    if (!newValue || newValue === oldValue) {
      return;
    }
    UserControl.customer.nachname = upperCaseFirst(newValue);
  });

  scope.$watch('UserControl.customer.nachname_del', function (newValue, oldValue) {
    if (!newValue || newValue === oldValue) {
      return;
    }
    UserControl.customer.nachname_del = upperCaseFirst(newValue);
  });
  scope.$watch('UserControl.customer.strasse', function (newValue, oldValue) {
    if (!newValue || newValue === oldValue) {
      return;
    }
    UserControl.customer.strasse = upperCaseFirst(newValue);
  });
  scope.$watch('UserControl.customer.strasse_del', function (newValue, oldValue) {
    if (!newValue || newValue === oldValue) {
      return;
    }
    UserControl.customer.strasse_del = upperCaseFirst(newValue);
  });
  scope.$watch('UserControl.customer.ort', function (newValue, oldValue) {
    if (!newValue || newValue === oldValue) {
      return;
    }
    UserControl.customer.ort = upperCaseFirst(newValue);
  });
  scope.$watch('UserControl.customer.ort_del', function (newValue, oldValue) {
    if (!newValue || newValue === oldValue || newValue.substring(-1) === ' ') {
      return;
    }
    UserControl.customer.ort_del = upperCaseFirst(newValue);
  });


  scope.$watch('UserControl.customer.emailRepeat', checkInlineDoubleEmail);
  scope.$watch('UserControl.customer.email', checkInlineDoubleEmail);

  scope.validateDoubleEmail = function () {
    const emailRepeatElement = document.getElementById("register-email-repeat");
    if (emailRepeatElement) {

      const mailValue = UserControl.customer.email;
      const repeatValue = UserControl.customer.emailRepeat;
      if (!mailValue || !repeatValue || mailValue.toLowerCase() !== repeatValue.toLowerCase()) {

        const translations = scope.translations;
        if (typeof translations[ 'custom' ] === "undefined" || typeof translations[ 'custom' ][ 'double_email_validation' ] === "undefined") {
          translations[ 'custom' ] = translations;
        }
        emailRepeatElement.setCustomValidity(translations[ 'custom' ][ 'double_email_validation' ]);
      } else {
        emailRepeatElement.setCustomValidity("");
      }
    }

  };


  scope.$watch('UserControl.customer.password', checkInlineDoublePassword);
  scope.$watch('UserControl.customer.passwordConfirm', checkInlineDoublePassword);

  scope.switchPasswordtype = function (selector) {
    const input = $(selector);
    const type = input.attr('type');
    if (type === 'password') {
      input.attr('type', 'text');
    } else {
      input.attr('type', 'password');
    }
  };

  scope.validateEmailForm = function () {

    scope.validateDoubleEmail();

    if (!UserControl.customer.email) {
      return;
    }

    scope.editEmail = false;
    scope.ajaxCall('login', 'validateEmail', 'POST', UserControl.customer, function (data) {

      if (!data.error) {
        UserControl.customer.loginRequired = true;
        UserControl.customer.id = null;


        if (data.isKnown) {
          UserControl.updateFormStatus('userKnown', true);
          UserControl.updateFormStatus('userNotKnown', false);

        } else {
          UserControl.updateFormStatus('userKnown', false);
          UserControl.updateFormStatus('userNotKnown', true);

          UserControl.customer.registerRequired = true;
        }

      }

      Mailchecker.check(scope.customer.email);
    });
  };

  scope.focusBirthdayMonth = function (valueToCheck) {
    if ((valueToCheck + '').length === 2) {
      const birthDay = document.getElementById('birthdayMonth');
      birthDay.focus();
    }
  };
  scope.focusBirthdayYear = function (valueToCheck) {
    if ((valueToCheck + '').length === 2) {
      const birthDay = document.getElementById('birthdayYear');
      birthDay.focus();
    }
  };

  scope.onGuestCheckboxClick = function () {
    const registerMode = UserControl.getFormStatus('registerMode');
    UserControl.setRegisterMode(!registerMode);
    if (registerMode) {
      UserControl.customer.password = '';
      UserControl.customer.passwordConfirm = '';
    }
  };

  /**
   *
   * @param {'login' | 'new' | 'amazonpay'} tab
   */
  scope.onChangeTab = function (tab) {
    UserControl.customer.password = '';
    UserControl.customer.passwordConfirm = '';
    if (tab === 'login') {
      UserControl.setLoginMode(true);
      UserControl.setRegisterMode(false);
      UserControl.setAmazonMode(false);
      UserControl.updateFormStatus('guestMode', false);
    } else if (tab === 'new') {
      UserControl.setLoginMode(false);
      UserControl.setAmazonMode(false);
      if (!UserControl.isGuestAllowed()) {
        UserControl.updateFormStatus('guestMode', false);
        UserControl.setRegisterMode(true);
      } else {
        UserControl.updateFormStatus('guestMode', true);
        UserControl.setRegisterMode(false);
      }
    } else if (tab === 'amazonpay') {
      UserControl.setAmazonMode(true);
      UserControl.setLoginMode(false);
      UserControl.setRegisterMode(false);
    }
  };

  /**
   * Used to preset postcode validation length by country
   * @param {string} countryISO3
   */
  function getPostcodeValidationPreset(countryISO3) {
    const countryMap = {
      'DEU': { min: 5, max: 5, regEx: /^\d{5}$/ },
      'FRA': { min: 5, max: 5, regEx: /^\d{5}$/ },
      'ESP': { min: 5, max: 5, regEx: /^\d{5}$/ },
      'AUT': { min: 4, max: 4, regEx: /^\d{4}$/ },
      'CHE': { min: 4, max: 4, regEx: /^\d{4}$/ },
      'NLD': { min: 7, max: 7, regEx: /^\d{4}\s[A-Za-z]{2}$/ },
      'NOR': { min: 4, max: 4, regEx: /^\d{4}$/ },
      'DNK': { min: 4, max: 4, regEx: /^\d{4}$/ },
      'GBR': { min: 5, max: 8, regEx: /^[A-Za-z][A-Za-z0-9]{1,3}\s?\d[A-Za-z]{2}$/ },
      'USA': { min: 5, max: 10, regEx: /(^\d{5}$)|(^\d{9}$)|(^\d{5}-\d{4}$)/ },
      // default case:
      '*': { min: 1, max: UserControl.formValidation.postcode.max, regEx: /^.*$/ }
    };
    return (countryMap.hasOwnProperty(countryISO3)) ? countryMap[ countryISO3 ] : countryMap[ '*' ];
  }
}

export default UserController;
